module.exports = __webpack_public_path__ + "img/maksim.v__600x600.985ce864.jpg";